import { render } from "./ContentblockNewsletter.vue?vue&type=template&id=597e7e0a&scoped=true"
import script from "./ContentblockNewsletter.js?vue&type=script&lang=js"
export * from "./ContentblockNewsletter.js?vue&type=script&lang=js"

import "./ContentblockNewsletter.scss?vue&type=style&index=0&id=597e7e0a&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597e7e0a"]])

export default __exports__